export const LICENSE_TYPES = {
  REGULAR: 'REGULAR',
  LIMITED: 'LIMITED',
} as const;

export type LicenseType = (typeof LICENSE_TYPES)[keyof typeof LICENSE_TYPES];
